export const URLS = { 
  GET_IP_URL: "https://api.ipify.org/?format=json",
  RENTS: 'https://toolsapi.rentometer.com:3000/renterui',
  QUICK_VIEW: 'https://www.rentometer.com/api/v1/summary',
  NEARBY_COMPS: 'https://www.rentometer.com/api/v1/nearby_comps',
  USER_AUTH: 'https://www.rentometer.com/api/v1/auth'
}

